<div class="comments-wrapper">
  <div class="comments-container">
    <div class="filter-form" [formGroup]="commentsFilterForm">
      <app-checkbox-form-field
        formControlName="showChatsOnly"
        [label]="'label.chat.show_chats_only' | translate"
        [viewMode]="false"
      ></app-checkbox-form-field>
    </div>
    @for (comment of comments; track comment;) {
    <div class="w-100">
      @if(comment.caseCommentType === COMMENT_TYPES.Comment || comment.caseCommentType === COMMENT_TYPES.Email) {
      <ng-container *ngTemplateOutlet="commentBox; context: { item: comment, chat: false }"></ng-container>
      }
      @if(comment.caseCommentType === COMMENT_TYPES.ChatConversation) {
      <ng-container *ngTemplateOutlet="chatBox; context: { item: comment }"></ng-container>
      }
    </div>
    }
    @if(!comments.length) {
      <div class="no-items-global">{{ 'label.no-conversation' | translate }}</div>
    }
  </div>
  @if(!disabled) {
    <div class="p-3 comments-bottom-section">
      <div class="add-comment-wrapper">
        <img [src]="'../../../../assets/img/person.png'">
        <div class="reply-to-text" *ngIf="replyTo">{{ 'label.reply_to' | translate }}: <span>{{replyTo}}</span></div>
        <form class="w-100" [formGroup]="commentForm">
            <app-rich-text-editor
              formControlName="content"
              [placeholder]="'label.type_comment_here'"
              [label]="''"
              [readonly]="false"
              [translatable]="false"
          >
          </app-rich-text-editor>
        </form>
      </div>
      <div class="submit-actions  pb-0">
        <button class="btn secondary-button" (click)="resetForm()">{{ 'label.cancel' | translate }}</button>
        <button class="btn primary-button" (click)="submitForm()" [disabled]="!commentForm.valid"
          translate="{{'label.add_comment'}}"></button>
      </div>
    </div>
  }
</div>

<ng-template #commentBox let-item="item" let-chat="chat">
  <div class="comment-box" [ngClass]="{'active-comment-box': item.id === activeId, 'chat-message-box': item.caseCommentType === COMMENT_TYPES.ChatMessage}">
    <img [src]="item?.imgUrl ? item.imgUrl : '../../../../assets/img/person.png' " class="user-avatar">
    <div class="comment-message">
      <div class="user">
        <div class="name">{{ item?.createdBy }}</div>
        <div class="date-time">{{ helperService.adjustDateFormatToUTCByAddingZ(item?.lastUpdatedAt) | date: 'MMM d, y • HH:mm' }}</div>
      </div>
      <div class="message">
        @if(chat) {
          <pre>{{ item?.content }}</pre>
        } @else {
          <app-rich-text-editor
            [readonly]="true"
            [editableInline]="false"
            [value]="item?.content"
          >
          </app-rich-text-editor>
        }
      </div>
    </div>
  </div>
  @if(item.caseCommentType !== COMMENT_TYPES.ChatMessage) {
  <div class="w-100 d-flex">
    <div class="case-comments-button" (click)="replyComment(item)">{{ 'label.reply' | translate}}</div>
    @if(item?.replyCount && item?.replyCount > 0 && !item?.hideLoadBtn) {
    <div class="case-comments-button ms-auto" (click)="loadReply(item)">{{ 'label.load_replies' | translate }}</div>
    }
  </div>
  }
  @if(item?.replies && item.replies.length && item.caseCommentType !== COMMENT_TYPES.ChatMessage) {
  <div class="reply-container">
    <div class="reply-arrow">
      <i class="bi bi-arrow-up-right"></i>
    </div>
    <div class="w-100">
      @for(reply of item.replies; track reply) {
      <ng-container *ngTemplateOutlet="commentBox; context: { item: reply, chat: false }"></ng-container>
      }
    </div>
  </div>
  }
</ng-template>

<ng-template #chatBox let-item="item">
  <div class="comment-box comment-box__chat">
    <div class="header">
      <i class="bi bi-chat-left-text"></i>
      <div class="title">
        <div class="name">{{ item.content }}</div>
        <div class="date-time">{{ helperService.adjustDateFormatToUTCByAddingZ(item?.lastUpdatedAt) | date: 'MMM d, y • HH:mm' }}</div>
      </div>
    </div>
    @for(chatMessage of item.childs; track chatMessage) {
    <ng-container *ngTemplateOutlet="commentBox; context: { item: chatMessage, chat: true }"></ng-container>
    }
  </div>
  <div class="w-100 d-flex">
    <div class="case-comments-button" (click)="replyComment(item)">{{ 'label.reply' | translate}}</div>
    @if(item?.replyCount && item?.replyCount > 0 && !item?.hideLoadBtn) {
    <div class="case-comments-button ms-auto" (click)="loadReply(item)">{{ 'label.load_replies' | translate }}</div>
    }
  </div>
  @if(item?.replies && item.replies.length) {
  <div class="reply-container">
    <div class="reply-arrow">
      <i class="bi bi-arrow-up-right"></i>
    </div>
    <div class="w-100">
      @for(reply of item.replies; track reply) {
      <ng-container *ngTemplateOutlet="commentBox; context: { item: reply, chat: false }"></ng-container>
      }
    </div>
  </div>
  }
</ng-template>
